export default __webpack_public_path__ + "static/media/jc.61713c10.png";